import { api } from "../utils/api";

const getTheme = async () => {
  const res = await api.get("Settings/theme");
  return res.data;
};

const getExternalInfo = async () => {
  const res = await api.get("Settings/getExternalInfo");
  return res.data;
};

const getForgotPasswordSupport = async () => {
  const res = await api.get("Settings/forgotPasswordSupport");
  return res.data;
};

const getEmployeeLoginOptions = async () => {
  const res = await api.get("Settings/employeeLoginOptions");
  return res.data;
};

const getI18n = async () => {
  const res = await api.get("Settings/i18n");
  return res.data;
};

export default {
  getTheme,
  getExternalInfo,
  getForgotPasswordSupport,
  getEmployeeLoginOptions,
  getI18n
};
